"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckboxEl;
var _react = _interopRequireWildcard(require("react"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _hi = require("react-icons/hi");
var _api = require("primereact/api");
var _ripple = require("primereact/ripple");
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const prime_params = {
  ripple: true
};
function CheckboxEl({
  onChange,
  ...props
}) {
  const [id, setId] = (0, _react.useState)((0, _uniqid.default)());
  const ref = (0, _react.useRef)();
  const is__disabled = (0, _utilities.isTrue)(props['read-only']);
  const modifiers = (0, _react.useMemo)(function () {
    const modifiers = [].concat(props.bemit || []);
    if (props.checked) modifiers.push('checked');
    if (is__disabled) modifiers.push('disabled');
    if (props.error && props.show_error) modifiers.push('error');
    if (props.required) modifiers.push('required');
    return modifiers;
  }, [props.checked, is__disabled, props.bemit, props.error, props.show_error, props.required]);
  const handleClick = (0, _react.useCallback)(function (e) {
    // permet d'éviter de focus l'input lorsqu'il s'agit d'un clic souris
    // et pas espace/enter (il n'y a pas de façon de savoir si c'est un click souris)
    // et mousedown/up sont exclus (la checkbox se coche après)
    if (e.target !== ref.current) {
      e.preventDefault();
      ref.current?.blur?.();
      onChange();
    }
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _bemit.default)('c-checkbox', modifiers) + (props.className ? ' ' + props.className : ''),
    htmlFor: id,
    onClick: is__disabled ? undefined : handleClick
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: props.checked,
    id: id,
    name: props.name,
    onChange: onChange,
    ref: ref,
    disabled: is__disabled
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-checkbox__indicator"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _bemit.default)('c-form-element-label', modifiers.concat(['checkbox']))
  }, props.label), /*#__PURE__*/_react.default.createElement(_api.PrimeReactProvider, {
    value: prime_params
  }, /*#__PURE__*/_react.default.createElement(_ripple.Ripple, null)), props.show_error && props.error ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _bemit.default)('c-field-error', ['checkbox'])
  }, /*#__PURE__*/_react.default.createElement(_hi.HiOutlineExclamation, {
    className: "c-field-error__icon"
  }), props.error) : undefined);
}
